/**
 * Token_Handler.ts
 * Lightweight wrapper around AsyncStorage for persisting non-sensitive
 * UI data (orgId, user display name). Auth tokens are handled server-side
 * via httpOnly cookies — never stored here.
 */

import AsyncStorage from '@react-native-async-storage/async-storage';

const KEYS = {
  ORG_ID:        'sk_queue_org_id',
  BUSINESS_NAME: 'sk_queue_business_name',
  FIRST_NAME:    'sk_queue_first_name',
  LAST_NAME:     'sk_queue_last_name',
};

export const Token_Handler = {
  setOrgId:        (v: string) => AsyncStorage.setItem(KEYS.ORG_ID, v),
  getOrgId:        ()          => AsyncStorage.getItem(KEYS.ORG_ID),
  setBusinessName: (v: string) => AsyncStorage.setItem(KEYS.BUSINESS_NAME, v),
  getBusinessName: ()          => AsyncStorage.getItem(KEYS.BUSINESS_NAME),
  setFirstName:    (v: string) => AsyncStorage.setItem(KEYS.FIRST_NAME, v),
  getFirstName:    ()          => AsyncStorage.getItem(KEYS.FIRST_NAME),
  setLastName:     (v: string) => AsyncStorage.setItem(KEYS.LAST_NAME, v),
  getLastName:     ()          => AsyncStorage.getItem(KEYS.LAST_NAME),
  clearAll: async () => {
    // Remove each key individually — the web AsyncStorage shim doesn't
    // implement multiRemove, and per-key removeItem works on every platform.
    await Promise.all(Object.values(KEYS).map((k) => AsyncStorage.removeItem(k)));
  },
};
